import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>There was an error...</Typography>
      <p>We are sorry for the inconvienience.</p>
      <p>Please get in touch if there is a repeart.</p>
    </div>
  )
}

export default HelpText